export default __webpack_public_path__ + "static/media/diarrhea.66b53cae.png";